import { Module } from "../../types/Module";

export type { Module };

export type CreateModuleRequest = Omit<Module, "id" | "createdAt" | "updatedAt">;
export type UpdateModuleRequest = Partial<Module>;

export enum ModuleState {
  NOT_AVAILABLE = "not_available",
  AVAILABLE = "available",
  IN_PROGRESS = "in-progress",
  NEEDS_PURCHASE = "needs_purchase",
}

export interface ModuleStatistics {
  exercisesCompleted: number;
  totalExercises: number;
  lessonsWatched: number;
  totalLessons: number;
  timeSpent: string; // Format like "8h 45min"
  averageScore: number; // Percentage
}

export interface ModuleAchievement {
  id: string;
  name: string;
  icon: string; // Icon identifier to be used in the UI
  description?: string;
}

export interface ModuleInfo {
  id: string;
  name: string;
  description: string;
  title: string;
  summarizedDescription: string;
  level: string; // e.g., "Iniciante", "Intermediário", "Avançado"
  duration: string; // e.g., "8 Semanas"
  hasCertificate: boolean;
  statistics: ModuleStatistics;
  achievements: ModuleAchievement[];
  state: ModuleState; // Module state from student's perspective
}
